<template>
  <a-layout class="main__container">
    <div class="tit">
      <img src="../assets/home/icon_img31.png" alt="" @click="back()" />
      <div class="tit-r">
        <div class="name">{{ getCategoryName($route.query.category) }}</div>
        <div class="en">The world famous paintings</div>
      </div>
    </div>
    <div class="list">
      <div class="list_c">
        <div
          class="item"
          v-for="(item, index) in courseList"
          :key="index"
          @click="detail(item.id)"
        >
          <img :src="item.cover" alt="" />
          <div class="item_t">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </a-layout>
</template>

<script>
import { getPublicCourseList } from "@/api";

export default {
  name: "PublicWelfareClass",
  data() {
    return {
      courseList: [],
    };
  },
  created() {
    this.getPublicCourseList();
  },
  methods: {
    async getPublicCourseList() {
      const { data } = await getPublicCourseList({
        category: this.$route.query.category,
      });
      this.courseList = data.rows;
    },
    detail(id) {
      this.$router.push({
        name: "PublicWelfareClassDetail",
        query: { id },
      });
    },
    back() {
      this.$router.back();
    },
    getCategoryName() {
      return this.$route.query.category === 1
        ? "绘画类"
        : this.$route.query.category === 2
        ? "书法类"
        : this.$route.query.category === 3
        ? "立体造型类"
        : "数字创意类";
    },
  },
};
</script>

<style scoped lang="less">
.main__container {
  background-color: #eef0f3;
  padding-top: 72px;
  .tit {
    display: flex;
    align-items: center;
    width: 1150px;
    margin: 32px auto;
    img {
      width: 24px;
      height: 24px;
      margin-right: 16px;
      cursor: pointer;
    }
    .tit-r {
      .name {
        font-weight: 500;
        font-size: 20px;
        color: #232324;
      }
      .en {
        font-weight: 500;
        font-size: 12px;
        color: rgba(35, 35, 36, 0.45);
      }
    }
  }
  .list {
    width: 1150px;
    margin: 0 auto 100px;
    .list_c {
      display: flex;
      flex-wrap: wrap;
      margin-left: -72px;
      .item {
        margin-left: 72px;
        margin-top: 48px;
        cursor: pointer;
        img {
          width: 334px;
          height: 334px;
          object-fit: cover;
        }
        .item_t {
          margin-top: 24px;
          font-weight: 500;
          font-size: 18px;
          color: #000000;
          display: -webkit-box;
          -webkit-line-clamp: 1; /* 设置显示的行数 */
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
